export default __webpack_public_path__ + "static/media/green-chk-cir.abc95c6c.svg";